module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "responsible-project-types"
  }, [_c('div', {
    staticClass: "placeholder mb-4"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_vm._v("\n            " + _vm._s(_vm.data.name) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "placeholder"
  }, [_c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.data.project_types,
      "search-options": _vm.searchOptions,
      "pagination-options": _vm.paginationOptions,
      "sort-options": _vm.sortOptions,
      "styleClass": _vm.styleClass,
      "row-style-class": _vm.selectedRowClass
    },
    on: {
      "on-row-click": _vm.selectProjectType
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'coverage_percent') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                        " + _vm._s(_vm._f("coveragePercent")(props.row.coverage_percent)) + " \n                        "), (props.row.coverage_percent !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_percent < _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.high.value
          }
        }) : _vm._e()]) : (props.column.field == 'total_revenue') ? _c('div', [_vm._v("\n                        " + _vm._s(_vm._f("currency")(props.row.total_revenue)) + "\n                    ")]) : (props.column.field == 'total_coverage') ? _c('div', [_vm._v("\n                        " + _vm._s(_vm._f("currency")(props.row.total_coverage)) + "\n                    ")]) : (props.column.field == 'coverage_per_hour') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                        " + _vm._s(_vm._f("currency")(props.row.coverage_per_hour)) + " \n                        "), (props.row.coverage_per_hour !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_per_hour < _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.high.value
          }
        }) : _vm._e()]) : _c('div', [_vm._v("\n                        " + _vm._s(props.formattedRow[props.column.field]) + "\n                    ")])]
      }
    }])
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n                    Ingen data ...\n                ")])])], 1)]), _vm._v(" "), (_vm.selectedRow) ? _c('responsible-projects', {
    attrs: {
      "data": _vm.selectedRow
    }
  }) : _c('div', [_vm._v("\n        Vælg en opgavetype for at se de enkelte opgaver her\n    ")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-168dfb51"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/responsibles/learning/components/responsibleProjectTypes.vue
// module id = 810
// module chunks = 0